import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmailVerificationInfo = ({ email, onResendVerification }) => {
  const [isResending, setIsResending] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);

  const handleResendVerification = async () => {
    if (resendCooldown > 0) return;

    setIsResending(true);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Start cooldown
      setResendCooldown(60);
      const interval = setInterval(() => {
        setResendCooldown(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      if (onResendVerification) {
        onResendVerification();
      }
    } catch (error) {
      console.error('Failed to resend verification:', error);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-6">
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="Mail" size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-foreground mb-2">
            E-Mail-Bestätigung erforderlich
          </h3>
          <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
            Wir haben eine Bestätigungs-E-Mail an{' '}
            <span className="font-medium text-foreground">{email}</span>{' '}
            gesendet. Bitte klicken Sie auf den Link in der E-Mail, um Ihr Konto zu aktivieren.
          </p>
          
          <div className="space-y-3">
            <div className="flex items-center space-x-2 text-xs text-muted-foreground">
              <Icon name="Clock" size={14} />
              <span>Die E-Mail kann bis zu 5 Minuten dauern</span>
            </div>
            <div className="flex items-center space-x-2 text-xs text-muted-foreground">
              <Icon name="AlertTriangle" size={14} />
              <span>Überprüfen Sie auch Ihren Spam-Ordner</span>
            </div>
          </div>

          <div className="mt-4 pt-4 border-t border-border">
            <p className="text-xs text-muted-foreground mb-3">
              Keine E-Mail erhalten?
            </p>
            <Button
              variant="outline"
              size="sm"
              onClick={handleResendVerification}
              loading={isResending}
              disabled={isResending || resendCooldown > 0}
              iconName="RefreshCw"
              iconPosition="left"
              iconSize={14}
            >
              {resendCooldown > 0 
                ? `Erneut senden in ${resendCooldown}s`
                : isResending 
                  ? 'Wird gesendet...' :'E-Mail erneut senden'
              }
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationInfo;